import React, { useState, useEffect, useMemo, Suspense } from "react";
import queryString from "query-string";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "../../assets/styles/main.scss";
import StoreContext from "./сontext/StoreContext";
import { getAuthUserName, Logout } from "../Auth/Utils";
import { loginBySaToken, retrieveBalances } from "../Auth/ApiCalls";
//import SongkranBg from "./backgrounds/Songkran";

const Layout = ({ children }) => {
  const [username, setUsername] = useState("");
  const [balanceTotal, setBalanceTotal] = useState("...");
  const [balanceFree, setBalanceFree] = useState("...");
  const [balanceFsg, setBalanceFsg] = useState("...");
  const [saLoginError, setSaLoginError] = useState("");

  const logoutFunc = () => {
    Logout();
    setUsername('');
  };

  const balanceUpdateFunc = (setBalanceLoading) => {
    retrieveBalances(setBalanceTotal, setBalanceFree, setBalanceFsg).then(() =>
    {
      setBalanceLoading(false);
    });
  };

  const contextValue = useMemo(
    () => ({ username, setUsername, logoutFunc, balanceUpdateFunc, balanceTotal, balanceFree, balanceFsg}),
    [username, balanceTotal, balanceFree, balanceFsg]
  );

  // const CustomBg = React.lazy(() =>
  //   import("./backgrounds/Halloween2024")
  // );

  useEffect(() => {
    const authUser = getAuthUserName();
    if (!authUser) {
      const location = window.location;
      const parsedSearch = queryString.parse(window.location.search);
      if ("Token" in parsedSearch) {
        loginBySaToken(parsedSearch.Token, setUsername, setSaLoginError).then(() => {
          window.history.replaceState({}, document.title, location.pathname);
        })
      }
    }

    if (authUser) {
      setUsername(authUser);
      retrieveBalances(setBalanceTotal, setBalanceFree, setBalanceFsg);
    }
  }, [username]);
  return (
    <StoreContext.Provider key="login-context-provider" value={contextValue}>
      <div className={"app-container"}>
        <div className={"app-content"}>
          {saLoginError &&
          <div className="sa-login-error" onClick={() => setSaLoginError("")}>
            {saLoginError}
          </div>}
          <Header className={username ? "header-logged" : "header-not-logged"} username={username}/>
          <main role="main" className={"app-content-main"}>
            {children}
          </main>
        </div>
        <Footer />
        <Suspense fallback={<div />}>
          {/*<CustomBg/>*/}
        </Suspense>
      </div>
    </StoreContext.Provider>

  );
};

export default Layout;
